import React, { useState } from "react";

const CORNERS = ["tl", "tr", "bl", "br"];

const SIZE_VARIANTS = {
  lg: {
    box: "w-[0.92em] h-[1.45em] -left-[0.32em]",
    dotSize: "w-[6px] h-[6px]",
    dotOffset: "-3px",
  },
  md: {
    box: "w-[0.95em] h-[1.4em] -left-[0.3em]",
    dotSize: "w-[5px] h-[5px]",
    dotOffset: "-2.5px",
  },
  sm: {
    box: "w-[0.95em] h-[1.35em] -left-[0.28em]",
    dotSize: "w-[4px] h-[4px]",
    dotOffset: "-2px",
  },
};

function dotStyleForCorner(corner, offset) {
  switch (corner) {
    case "tl":
      return { top: offset, left: offset };
    case "tr":
      return { top: offset, right: offset };
    case "bl":
      return { bottom: offset, left: offset };
    case "br":
    default:
      return { bottom: offset, right: offset };
  }
}

/**
 * BoxedTitle — wraps a title (or heading line) with an outlined square that
 * overlaps the start of the text. The text passes through the box's right
 * edge; only the box outline is visible (no fill).
 *
 * Each instance also gets a small solid red square at a RANDOM corner of
 * its outlined box — only "real" boxes are associated with the red dot.
 */
export default function BoxedTitle({
  children,
  size = "md",
  boxColor = "border-[#0a0a0a]",
  dotColor = "bg-[#e34234]",
  showDot = true,
  thick = false,
  className = "",
  testid,
}) {
  const variant = SIZE_VARIANTS[size] || SIZE_VARIANTS.md;
  const borderWidth = thick ? "border-[2px]" : "border";

  // Pick a random corner once per mount.
  const [corner] = useState(
    () => CORNERS[Math.floor(Math.random() * CORNERS.length)]
  );
  const dotStyle = dotStyleForCorner(corner, variant.dotOffset);

  return (
    <span
      className={`relative inline-block align-baseline ${className}`}
      data-testid={testid}
    >
      <span
        aria-hidden="true"
        className={`absolute top-1/2 -translate-y-1/2 ${borderWidth} ${boxColor} ${variant.box}`}
      >
        {showDot && (
          <span
            aria-hidden="true"
            className={`absolute ${variant.dotSize} ${dotColor}`}
            style={dotStyle}
            data-corner={corner}
          />
        )}
      </span>
      <span className="relative">{children}</span>
    </span>
  );
}
